import { api } from "../ApiState";
import { IApiResponse } from "../../Types/ApiResponse.model";

export const transactionApi = api.injectEndpoints({
  endpoints: (builder) => ({
    // list
    getTransactionList: builder.query<
      any,
      { search?: object; page?: number; deleted?: boolean }
    >({
      query: ({ search, page, deleted }) => ({
        url: "transaction/list",
        method: "GET",
        params: {
          ...(search && { search: JSON.stringify({ ...search }) }),
          ...(page && { page }),
          ...(deleted && { deleted }),
        },
      }),
      providesTags: ["Transaction"],
    }),

    // show
    getTransaction: builder.query<any, number>({
      query: (id) => ({
        url: `transaction/${id}`,
        method: "GET",
      }),
      transformResponse(baseQueryReturnValue: IApiResponse) {
        return baseQueryReturnValue?.response?.data;
      },
      providesTags: ["Transaction"],
    }),

    // create
    storeTransaction: builder.mutation<any, any>({
      query: (data) => ({
        url: "transaction",
        method: "POST",
        body: data,
      }),
      invalidatesTags: (result) => (result ? [{ type: "Transaction" }] : []),
    }),

    // update
    updateTransaction: builder.mutation<
      IApiResponse<any>,
      { id: number; value: object }
    >({
      query: ({ id, value }) => ({
        url: `transaction/${id}`,
        method: "POST",
        body: { ...value, _method: "PUT" },
      }),
      invalidatesTags: (result) => (result ? [{ type: "Transaction" }] : []),
    }),

    // delete
    deleteTransaction: builder.mutation<IApiResponse<any>, number>({
      query: (id) => ({
        url: `transaction/${id}`,
        method: "POST",
        body: { _method: "PUT" },
      }),
      invalidatesTags: (result) => (result ? [{ type: "Transaction" }] : []),
    }),

    // restore
    restoreTransaction: builder.mutation<IApiResponse<any>, number>({
      query: (id) => ({
        url: `transaction/restore/${id}`,
        method: "POST",
        body: { _method: "PUT" },
      }),
      invalidatesTags: (result) => (result ? [{ type: "Transaction" }] : []),
    }),

    // new comment for transction
    storeCommentTransaction: builder.mutation<
      IApiResponse<any>,
      { transactionId: number; comment: string }
    >({
      query: ({ transactionId, comment }) => ({
        url: "transaction/comment",
        method: "POST",
        body: { comment: comment, transaction_id: transactionId },
      }),
      invalidatesTags: (result) => (result ? [{ type: "Transaction" }] : []),
    }),

    // update comment for transction
    updateCommentTransaction: builder.mutation<
      IApiResponse<any>,
      { commentId: number; comment: string }
    >({
      query: ({ commentId, comment }) => ({
        url: `transaction/comment/${commentId}`,
        method: "POST",
        body: { comment: comment, _method: "PUT" },
      }),
      invalidatesTags: (result) => (result ? [{ type: "Transaction" }] : []),
    }),

    // delete comment for transction
    deleteCommentTransaction: builder.mutation<IApiResponse<any>, number>({
      query: (commentId) => ({
        url: `transaction/comment/${commentId}`,
        method: "POST",
        body: { _method: "DELETE" },
      }),
      invalidatesTags: (result) => (result ? [{ type: "Transaction" }] : []),
    }),

    // restore comment for transction
    restoreCommentTransaction: builder.mutation<IApiResponse<any>, number>({
      query: (commentId) => ({
        url: `transaction/comment/restore/${commentId}`,
        method: "POST",
        body: { _method: "PUT" },
      }),
      invalidatesTags: (result) => (result ? [{ type: "Transaction" }] : []),
    }),

    // change status list
    successTransactionStatus: builder.mutation<IApiResponse<any>, number>({
      query: (id) => ({
        url: `transaction/change-status-to-success/${id}`,
        method: "POST",
        body: { _method: "PUT" },
      }),
      invalidatesTags: (result) => (result ? [{ type: "Transaction" }] : []),
    }),

    getTransactionReport: builder.query<IApiResponse<any>, { search?: object }>(
      {
        query: ({ search }) => ({
          url: "report/transaction",
          method: "GET",
          params: {
            ...(search && { search: JSON.stringify({ ...search }) }),
          },
        }),
      }
    ),
  }),
});

export const {
  useGetTransactionListQuery,
  useGetTransactionQuery,
  useStoreTransactionMutation,
  useUpdateTransactionMutation,
  useDeleteTransactionMutation,
  useRestoreTransactionMutation,
  useStoreCommentTransactionMutation,
  useUpdateCommentTransactionMutation,
  useDeleteCommentTransactionMutation,
  useRestoreCommentTransactionMutation,
  useSuccessTransactionStatusMutation,
  useGetTransactionReportQuery,
} = transactionApi;

export default transactionApi;
